import axios from 'axios';

export function getCustomCase (params) {
  return axios.postForm('/api/contentInfoNoPage.jspx', params);
}

export function getApplication (params) {
  return axios.postForm('/api/contentInfoNoPage.jspx', params);
}

export function getCustomLogo (params) {
  return axios.postForm('/api/contentInfoNoPage.jspx', params);
}

export function getCustomComment (params) {
  return axios.postForm('/api/contentInfoNoPage.jspx', params);
}

export function getArticleContent (params) {
  return axios.get('/api/contentTxtByContentId.jspx?contentId='+params);
}




// WEBPACK FOOTER //
// ./src/api/casePage.js